<template>
  <div class="desk-frame contact-page">
    <div class="head_row_calander bg--white flex no_mobile">
      <h1 class="title title--40 no-marge tx--blue2">
        הגשה לוועדת חריגים
      </h1>
      <button
        v-show="!formSent"
        @click.stop="onSubmit"
        class="bt_blue"
        style="padding: 0 35px;"
      >
        שלח
        <vue-loaders-ball-clip-rotate
          v-show="sending"
          color="white"
          scale="1.2"
          style="position: relative;top: 10px;"
        ></vue-loaders-ball-clip-rotate>
      </button>
    </div>
    <menu-desktop class="no_mobile" />

    <DashboardHeader />
    <transition name="slide">
      <Menu v-if="MENU_ACTIVE" />
    </transition>

    <transition name="slide">
      <section class="calandr_main">
        <ValidationObserver ref="approvalform">
          <form v-show="!formSent" @submit.prevent="onSubmit">
            <div
              class="inner_group bg--white desk_inner_width desk-flex desk-flex--top desk-flex--start split-3 desk-no-pad"
              style="margin-bottom: 0;"
            >
              <div
                v-for="field in fields"
                :key="field.name"
                class="add_new_row flex"
              >
                <div class="add_new_row_col1">{{ field.label }}</div>
                <div class="add_new_row_col2">
                  <validation-provider
                    :name="field.name"
                    :rules="field.rules"
                    v-slot="{ errors }"
                    class="input-opacity"
                  >
                    <input
                      v-if="
                        field.name === 'patientBirthDate' ||
                          field.name === 'surgeryDate'
                      "
                      :type="field.inputType"
                      :name="field.name"
                      v-model="formaData[field.name]"
                      v-mask="['##/##/####']"
                      :placeholder="field.placeholder"
                    />
                    <input
                      v-else
                      :type="field.inputType"
                      :name="field.name"
                      v-model="formaData[field.name]"
                      :placeholder="field.placeholder"
                    />
                    <span class="error-message">{{ errors[0] }}</span>
                  </validation-provider>
                </div>
              </div>
            </div>

            <div class="mb--22" style="background-color: white;">
              <div class="book_surgery_top">
                אנא פרט/י מהי הסיבה לדחיפות הטיפול
              </div>
              <div class="book_surgery_open">
                <textarea v-model="formaData.msg" style="min-height: 130px;" />
              </div>

              <div class="error-message" v-if="errorMessage">
                {{ errorMessage }}
              </div>
            </div>

            <div class="special-approval-btn-container">
              <button type="submit" class="bt_blue">
                שלח
                <vue-loaders-ball-clip-rotate
                  v-show="sending"
                  color="white"
                  scale="1.2"
                  style="position: relative;top: 10px;"
                ></vue-loaders-ball-clip-rotate>
              </button>
            </div>
          </form>
        </ValidationObserver>

        <div class="after-send m-center" v-show="formSent">
          <Thank />
          <div class="title tx--blue2">
            תודה, פנייתך נשלחה<br />
            בהצלחה!
          </div>
          <button class="bt_blue" @click="onBack">
            חזרה לתוכנית ניתוחים
          </button>
        </div>
      </section>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardHeader from "@/components/Shared/Header";
import Menu from "@/components/Shared/Menu";
import MenuDesktop from "@/components/Shared/MenuDesktop.vue";
import { sendCelloSign } from "../api/api-quatro.js";
import Thank from "@/assets/img/svg/thank.svg";

export default {
  name: "SurgSpecialApproval",
  components: {
    DashboardHeader,
    Menu,
    MenuDesktop,
    Thank
  },
  data() {
    return {
      formSent: false,
      sending: false,
      errorMessage: "",
      formaData: {
        surgeryId: this.$route.params.id,
        doctorName: "",
        patientName: "",
        patientPassport: "",
        patientBirthDate: "",
        surgeryDate: "",
        surgeryTime: "",
        surgeryName: "",
        hospitalization: "",
        msg: ""
      },
      fields: [
        {
          label: "שם המטופל*",
          name: "patientName",
          inputType: "text",
          rules: "required"
        },
        {
          label: "מספר ת.ז*",
          name: "patientPassport",
          inputType: "text",
          rules: "required"
        },
        {
          label: "תאריך לידה*",
          name: "patientBirthDate",
          inputType: "text",
          rules: "required|birth_date"
        },
        {
          label: "תאריך ניתוח*",
          name: "surgeryDate",
          inputType: "text",
          rules: "required|valid_date"
        },
        {
          label: "שם הניתוח*",
          name: "surgeryName",
          inputType: "text",
          rules: "required"
        },
        {
          label: `סה"כ ימי אשפוז*`,
          name: "hospitalization",
          inputType: "text",
          rules: "required"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["MENU_ACTIVE"])
  },
  methods: {
    onBack() {
      this.$router.push("/dashboard/surgeries");
    },
    async onSubmit() {
      try {
        const isValid = await this.$refs.approvalform.validate();

        if (this.sending || !isValid) return;
        this.errorMessage = "";
        this.sending = true;

        const patientNameParts = this.formaData.patientName.split(" ");
        const firstname = patientNameParts[0];
        const lastname = patientNameParts.slice(1).join(" ");

        let formattedBirthDate = "";
        let formattedSurgeryDate = "";

        if (this.formaData.patientBirthDate) {
          formattedBirthDate = this.$moment(
            this.formaData.patientBirthDate,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
        }

        if (this.formaData.surgeryDate) {
          formattedSurgeryDate = this.$moment(
            this.formaData.surgeryDate,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");

          formattedSurgeryDate += " ";
          formattedSurgeryDate += this.formaData.surgeryTime || "00:00:00";
        }

        const payload = {
          surgery_id: this.formaData.surgeryId,
          name: this.formaData.doctorName,
          firstname: firstname,
          lastname: lastname,
          passport: this.formaData.patientPassport,
          start_date: formattedSurgeryDate,
          surgery_name: this.formaData.surgeryName,
          hospitalization: this.formaData.hospitalization,
          FTzpH2DJdnUe: this.formaData.msg,
          birthDate: formattedBirthDate
        };

        const response = await sendCelloSign(payload, "exception-committee");
        if (response.status === "success") {
          this.formSent = true;
        } else {
          this.errorMessage = "שליחת הטופס נכשלה. אנא נסה שוב מאוחר יותר.";
        }
      } catch (error) {
        console.error("Error sending form to CelloSign:", error);
        this.errorMessage = "אירעה שגיאה בלתי צפויה בעת שליחת הטופס.";
      } finally {
        this.sending = false;
      }
    }
  },
  async created() {
    if (!this.$route.params.id) return;
    const res = await this.$API.getSurgeryInfo(this.$route.params.id);
    let birthDate;
    if (res.message.patient.birthDate) {
      birthDate = this.$moment(
        res.message.patient.birthDate,
        "YYYY-MM-DD"
      ).format("DD/MM/YYYY");
    }
    let surgDate;
    let surgTime;
    if (res.message.surgery.start_date) {
      surgTime = this.$moment(
        res.message.surgery.start_date,
        "YYYY-MM-DDTHH:mm:ss"
      ).format("HH:mm:ss");

      surgDate = this.$moment(
        res.message.surgery.start_date,
        "YYYY-MM-DD"
      ).format("DD/MM/YYYY");
    }
    this.formaData.patientName = `${res.message.patient.firstName} ${res.message.patient.lastName}`;
    this.formaData.patientPassport = res.message.patient.passport;
    this.formaData.patientBirthDate = birthDate;
    this.formaData.surgeryDate = surgDate;
    this.formaData.surgeryTime = surgTime;
    this.formaData.surgeryName = res.message.surgery.name;
    this.formaData.hospitalization = res.message.surgery.hospitalization;
    this.formaData.doctorName = res.message.doctor.heb_name;
  }
};
</script>
